export default "__VITE_ASSET__z0fxTWHu__"